import { Grid, IconButton } from '@mui/material';
import React, { useEffect } from 'react';
import AutocompleteSelect from '../../../Components/AutocompleteSelect';
import CustomButton from '../../../Components/CustomButton';
import { scheduleTypes } from '../../../Utils/constantData';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { useFieldArray } from 'react-hook-form';
import DateInput from '../../../Components/DateInput';
import Images from '../../../Utils/images';
import { useParams } from 'react-router-dom';

const Schedule = ({
  control,
  errors,
  watch,
  setValue,
  getValues,
  trigger,
}: any) => {
  const { fields, append, remove }: any = useFieldArray({
    control,
    name: 'schedule',
  });

  const { productionId }: any = useParams();

  const handleAddEntity = () => {
    append({ startDate: '', scheduleType: null, endDate: '' });
  };

  const handleAddSchedule = (index: number, v: any) => {
    const schedule = getValues('schedule') || [];
    const updated = [...schedule];

    updated[index] = {
      ...updated[index],
      scheduleType: v,
      startDate: v.value === 'Development' ? new Date() : '',
      endDate:
        v.value === 'Development'
          ? (() => {
              const end = new Date();
              end.setFullYear(end.getFullYear() + 2);
              return end;
            })()
          : '',
    };

    const ordered = updated.sort((a, b) => {
      const aIdx = scheduleTypes.findIndex(
        t => t.value === a.scheduleType?.value,
      );
      const bIdx = scheduleTypes.findIndex(
        t => t.value === b.scheduleType?.value,
      );
      return aIdx - bIdx;
    });

    setValue('schedule', ordered, { shouldValidate: true, shouldDirty: true });
  };

  useEffect(() => {
    const schedule = getValues('schedule') || [];
    const ordered = [...schedule].sort((a, b) => {
      const aIdx = scheduleTypes.findIndex(
        t => t.value === a.scheduleType?.value,
      );
      const bIdx = scheduleTypes.findIndex(
        t => t.value === b.scheduleType?.value,
      );
      return aIdx - bIdx;
    });
    if (JSON.stringify(schedule) !== JSON.stringify(ordered)) {
      setValue('schedule', ordered);
    }
  }, []);

  return (
    <>
      {fields.map((item: any, index: number) => (
        <Grid container spacing={2} key={item.id}>
          <Grid item md={4} xs={12}>
            <AutocompleteSelect
              id="Production Type *"
              labelText="Schedule Type"
              placeHolderText="Select schedule type"
              options={scheduleTypes.filter(
                type =>
                  !watch('schedule')
                    ?.map((s: any, i: number) =>
                      i === index ? null : s?.scheduleType?.value,
                    )
                    ?.includes(type.value),
              )}
              defaultValue={''}
              requiredField
              labelKey="label"
              control={control}
              onChange={(e: any, value: any) => {
                handleAddSchedule(index, value);
                trigger(`schedule.${index}.scheduleType`);
              }}
              name={`schedule.${index}.scheduleType`}
              setValue={setValue}
              error={
                !!errors['schedule'] &&
                !!errors['schedule'][index]?.scheduleType
              }
              helperText={
                !!errors['schedule']
                  ? errors['schedule'][index]?.scheduleType?.message
                  : ''
              }
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <DateInput
              name={`schedule.${index}.startDate`}
              label="From Date"
              formProps={{ control }}
              requiredField={true}
              error={
                !!errors['schedule'] && !!errors['schedule'][index]?.startDate
              }
              helperText={
                !!errors['schedule']
                  ? errors['schedule'][index]?.startDate?.message
                  : ''
              }
              disabled={
                watch(`schedule.${index}.scheduleType`)?.value === 'Development'
              }
              value={getValues(`schedule.${index}.startDate`)}
              onChange={(e: any) => {
                setValue(`schedule.${index}.startDate`, e);
                trigger(`schedule.${index}.startDate`);
                if (watch(`schedule.${index}.endDate`)) {
                  trigger(`schedule.${index}.endDate`);
                }
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid
              container
              spacing={2}
              direction={'row'}
              alignItems={'flex-end'}
            >
              <Grid item md={10} xs={12}>
                <DateInput
                  name={`schedule.${index}.endDate`}
                  value={getValues(`schedule.${index}.endDate`)}
                  requiredField
                  label="To Date"
                  formProps={{ control }}
                  error={
                    !!errors['schedule'] && !!errors['schedule'][index]?.endDate
                  }
                  disabled={
                    watch(`schedule.${index}.scheduleType`)?.value ===
                    'Development'
                  }
                  helperText={
                    !!errors['schedule']
                      ? errors['schedule'][index]?.endDate?.message
                      : ''
                  }
                  minDate={new Date(watch(`schedule.${index}.startDate`))}
                  onChange={(e: any) => {
                    setValue(`schedule.${index}.endDate`, e);
                    trigger(`schedule.${index}.endDate`);
                    if (watch(`schedule.${index}.startDate`)) {
                      trigger(`schedule.${index}.startDate`);
                    }
                  }}
                />
              </Grid>

              <Grid item md={2} xs={12}>
                <div
                  className={`discount_action ${
                    !!errors['custom'] &&
                    !!errors['custom'][index]?.usageLimit &&
                    'on_error'
                  }`}
                >
                  {/* {index !== 0 && ( */}
                  {!getValues()?.orderProductionScheduleType?.includes(
                    item?.scheduleType?.label,
                  ) && (
                    <IconButton
                      className="btn_delete square"
                      onClick={() => remove(index)}
                      id="delete-schedule"
                      onKeyDown={event => {
                        if (event.key === 'Enter') {
                          const target = event.target as HTMLElement;
                          target.click();
                        }
                      }}
                      disabled={fields?.length === 1}
                    >
                      <img src={Images.TRASH} />
                    </IconButton>
                  )}
                  {/* )} */}
                </div>
              </Grid>
            </Grid>
          </Grid>

          {index === fields.length - 1 && fields.length <= 4 && (
            <Grid item md={12} xs={12}>
              <div className="flex end">
                <CustomButton
                  onClick={handleAddEntity}
                  size="large"
                  variant="contained"
                  text={'Add'}
                  showIcon={true}
                  width="auto"
                  disabled={
                    fields.length === 5 ||
                    !(
                      watch(`schedule.${index}.scheduleType`) &&
                      watch(`schedule.${index}.startDate`) &&
                      watch(`schedule.${index}.endDate`)
                    ) ||
                    !!(
                      errors.schedule?.[index]?.scheduleType ||
                      errors.schedule?.[index]?.startDate ||
                      errors.schedule?.[index]?.endDate
                    )
                  }
                  type="button"
                  id="filter"
                  loading={false}
                  iconPosition="start"
                  iconType="svg"
                  icon={<AddOutlinedIcon />}
                />
              </div>
            </Grid>
          )}
        </Grid>
      ))}
    </>
  );
};

export default Schedule;
